import { render, staticRenderFns } from "./CertificateAdd.vue?vue&type=template&id=2c74e9b5&"
import script from "./CertificateAdd.vue?vue&type=script&lang=js&"
export * from "./CertificateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports